import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import AppCampaigns from 'components/AppCampaigns'

export const AppCampaignsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <AppCampaigns />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
